import React from 'react'

// Components
import GeneralLoader from '../../../../GeneralLoader'
import Button from '../../../../utils/Button'
import ErrorWrap from '../../../../utils/error-success/ErrorWrap'
import SuccessWrap from '../../../../utils/error-success/SuccessWrap'

const AdminMassEmailSend = ({
    loading, errors, success, handleEmailSubmit
}) => {
    return (
        <React.Fragment>
            {loading ? 
                <GeneralLoader/> : 
                <div className="fieldset">
                    <div className="title-label">Send Mass Email</div>

                    <div className="fieldset-indent">
                        {/* Submit Mass Email Button*/}
                        <div style={{margin: '2em 0 0.5em 0'}}>
                            <strong>Note: </strong>Before sending an email, please change any options above and click "Save Options" before you send out the mass email.
                        </div>

                        <div className="btn_container pt1">
                            {!!errors.general && (
                                <ErrorWrap animate={1}>{errors.general}</ErrorWrap>
                            )}
                            {success && <SuccessWrap>{success}</SuccessWrap>}

                            <Button
                                text="Send Mass Email"
                                clickHandler={() => handleEmailSubmit()}
                                isLoading={loading}
                            />
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}

export default AdminMassEmailSend


// WEBPACK FOOTER //
// ./src/components/admin/reviews/reviews-email/mass-email/AdminMassEmailSend.js